import { application } from "./application";
import Favourite from "./favourite_controller";
import Favourites from "./favourites_controller";
import FlashMessage from "./flash_message_controller";

application.register("favourite", Favourite);
application.register("favourites", Favourites);
application.register("flash-message", FlashMessage);

const controllerMap = {
  "admin-ab-tests-pill": () => import("./admin_ab_tests_pill_controller"),
  "change-store": () => import("./change_store_controller"),
  clipboard: () => import("./clipboard_controller"),
  "core-web-vitals": () => import("./core_web_vitals_controller"),
  cookie: () => import("./cookie_controller"),
  dialog: () => import("./dialog_controller"),
  drawer: () => import("./drawer_controller"),
  "advent-calendar-reveal": () => import("./advent_calendar_reveal_controller"),
  "dynamic-bundle": () =>
    Promise.all([
      {
        name: "dynamic-bundle",
        import: import("./dynamic_bundles/listing_controller")
      },
      {
        name: "dynamic-bundle-swatch",
        import: import("./dynamic_bundles/colour_swatch_controller")
      },
      {
        name: "dynamic-bundle-listing-image",
        import: import("./dynamic_bundles/listing_image_controller")
      }
    ]),
  dropdown: () => import("./dropdown_controller"),
  "listing-tile": () => import("./listing_tile_controller"),
  "plp-grid": () => import("./plp_grid_controller"),
  modal: () => import("./modal_controller"),
  "stock-status-subscription": () => import("./stock_status_controller"),
  popup: () => import("./popup_controller"),
  "mega-menu": () => import("./mega_menu_controller"),
  "mini-cart": () => import("./mini_cart_controller"),
  "nav-buttons": () => import("./nav_buttons_controller"),
  search: () => import("./search_controller"),
  "shipping-calculator": () => import("./shipping_calculator_controller"),
  "show-password": () => import("./show_password_controller"),
  "upsells-modal": () => import("./upsells_modal_controller"),
  "upsell-events": () => import("./upsell_events_controller"),
  personalisation: () => import("./personalisation_controller"),
  "photobook-page-option": () => import("./photobook_page_option_controller"),
  "scroll-carousel": () => import("./scroll_carousel_controller"),
  "sticky-cta": () => import("./sticky_cta_controller")
};

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-controller]").forEach(element => {
    const controllerName = element.getAttribute("data-controller");
    const loader = controllerMap[controllerName];

    if (loader) {
      loader()
        .then(module => {
          if (Array.isArray(module)) {
            module.forEach(({ name, import: controller }) => {
              controller.then(ctrlModule => {
                application.register(name, ctrlModule.default);
              });
            });
          } else {
            application.register(controllerName, module.default);
          }
        })
        .catch(error => {
          console.error(`Error loading ${controllerName} controller:`, error);
        });
    }
  });
});

document.addEventListener("turbo:frame-load", () => {
  document.querySelectorAll("[data-controller]").forEach(element => {
    const controllerName = element.getAttribute("data-controller");
    const loader = controllerMap[controllerName];

    if (loader && !element.hasAttribute("data-controller-registered")) {
      element.setAttribute("data-controller-registered", "true");
      loader()
        .then(module => {
          if (Array.isArray(module)) {
            module.forEach(({ name, import: controller }) => {
              controller.then(ctrlModule => {
                application.register(name, ctrlModule.default);
              });
            });
          } else {
            application.register(controllerName, module.default);
          }
        })
        .catch(error => {
          console.error(`Error loading ${controllerName} controller:`, error);
        });
    }
  });
});
